// ============================================================================
// 📁 AttachmentsBlock.js
// 🎨 Premium SaaS UI — Attachment List + Upload
// ============================================================================

import React from "react";
import { UploadOutlined } from "@ant-design/icons";
import { Button, Upload } from "antd";

export default function AttachmentsBlock({ attachments = [], onUpload }) {
  const uploadProps = {
    beforeUpload: (file) => {
      const formData = new FormData();
      formData.append("file", file);
      onUpload(formData);
      return false;
    },
  };

  return (
    <div
      className="tf-block"
      style={{
        background: "#fff",
        padding: "20px 24px",
        borderRadius: "14px",
        marginBottom: "22px",
        border: "1px solid #eee",
        boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
      }}
    >
      {/* Title */}
      <div
        style={{
          fontSize: "16px",
          fontWeight: 600,
          color: "#2a2344",
          marginBottom: "16px",
        }}
      >
        Attachments
      </div>

      {/* Upload Button */}
      <Upload {...uploadProps} showUploadList={false}>
        <Button
          icon={<UploadOutlined />}
          style={{
            marginBottom: "14px",
            borderRadius: "8px",
            padding: "6px 14px",
            fontWeight: 600,
          }}
        >
          Upload File
        </Button>
      </Upload>

      {/* Attachment List */}
      {attachments.map((file, idx) => (
        <div
          key={idx}
          style={{
            background: "#fff1fc",
            border: "1px solid #ffd3f7",
            padding: "14px 16px",
            borderRadius: "12px",
            marginBottom: "12px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <div style={{ fontSize: "14px", fontWeight: 600 }}>{file.name}</div>
            <div style={{ fontSize: "12px", opacity: 0.6 }}>
              {file.created_at}
            </div>
          </div>

          <a
            href={file.url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#6A00F4",
              fontWeight: 600,
            }}
          >
            View
          </a>
        </div>
      ))}
    </div>
  );
}
